// ACTIONS

export const FETCH_DOCUMENT_TYPES = 'FETCH_DOCUMENT_TYPES';
export const FETCH_DOCUMENT_TYPES_SUCCESS = 'FETCH_DOCUMENT_TYPES_SUCCESS';
export const FETCH_DOCUMENT_TYPES_FAILED = 'FETCH_DOCUMENT_TYPES_FAILED';

// INITIAL STATE
const initialState = {
  data: [],
  loading: false,
};

// STORE
function documentTypes(state = initialState, action) {
  const { data } = action;
  switch (action.type) {
    case FETCH_DOCUMENT_TYPES:
      return {
        ...state,
        loading: true,
      };
    case FETCH_DOCUMENT_TYPES_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case FETCH_DOCUMENT_TYPES_FAILED:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}

// ACTION CREATORS
export function fetchDocumentTypes(showLoader = false, message) {
  return {type: FETCH_DOCUMENT_TYPES, showGlobalLoader: showLoader, message}
}

export function fetchDocumentTypesSuccess(types) {
  return {type: FETCH_DOCUMENT_TYPES_SUCCESS, data: types, hideGlobalLoader: true}
}

export function fetchDocumentTypesFailed() {
  return {type: FETCH_DOCUMENT_TYPES_FAILED, hideGlobalLoader: true}
}

export default documentTypes;
